import * as Colors from '@brightlayer-ui/colors';
import { Search } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import React from 'react';

type SearchFieldProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    width?: string;
    color?: string;
    'data-testid'?: string;
};

export const SearchField: React.FC<SearchFieldProps> = ({
    value,
    onChange,
    placeholder,
    width = '280px',
    color = Colors.gray[500],
    'data-testid': dataTestId = 'search-field',
}) => (
    <TextField
        data-testid={dataTestId}
        placeholder={placeholder}
        variant="standard"
        value={value}
        onChange={(e): void => onChange(e.target.value)}
        slotProps={{
            input: {
                startAdornment: (
                    <InputAdornment position="start">
                        <Search sx={{ color }} />
                    </InputAdornment>
                ),
            },
        }}
        sx={{
            width,
            '& .MuiInput-root': {
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '22px',
                color,
                height: '40px',
            },
            '& .MuiInput-underline:before': {
                borderBottomColor: 'rgba(66, 78, 84, 0.12)',
            },
        }}
    />
);
